import { getRequiredFields } from 'utils/form'
import constants from 'constants'

const fields = [
  {
    label: '',
    name: 'role',
    layout: 'fullWidth',
    maxLength: 100,
    type: 'hidden',
  },
  {
    label: '',
    name: 'planStatus',
    layout: 'fullWidth',
    maxLength: 100,
    type: 'hidden',
  },
  {
    label: constants.PARTNERPLAN.PROGRESS_LABEL.AGREED_WITH_COUNSELLEE,
    name: 'planAgreedWithCounsellee',
    validators: [
      {
        check: 'required',
        error: constants.PARTNERPLAN.ERROR_MESSAGE.AGREED_WITH_COUNSELLEE,
      },
    ],
  },
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/PartnerPlanSubmittedForm.js